export default "__VITE_ASSET__XxgOeIi___"